import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { Send } from "@mui/icons-material";
import { Fragment, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createComment, getCommentsByActivity } from "../../api/comments";
import { handleAxiosError } from "../../config/action-config";
import {
  CircularProgress,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { useReducer } from "react";

const style = {
  chat: {
    backgroundColor: "#ededed",
    borderTopRightRadius: "5px",
    borderTopLeftRadius: "5px",
    borderBottomRightRadius: "5px",
  },
  chatSelf: {
    backgroundColor: "#ededed",
    borderTopRightRadius: "5px",
    borderTopLeftRadius: "5px",
    borderBottomLeftRadius: "5px",
  },
};

const initReducerState = { comments: [], loadSuspense: true, tempChats: [] };

const localReducer = (state, action) => {
  switch (action.type) {
    case "INIT_CHAT_LOAD":
      return { ...state, loadSuspense: true };
    case "COMPLETE_CHAT_LOAD":
      return { ...state, comments: action.payload, loadSuspense: false };
    case "INIT_CHAT_SEND":
      return { ...state, tempChats: [...state.tempChats, action.payload] };
    case "COMPLETE_CHAT_SEND":
      return {
        ...state,
        comments: [...state.comments, action.payload],
        tempChats: state.tempChats.filter(
          (c) => c.id !== action.payload.tempId
        ),
      };
    default:
      return state;
  }
};

export default function ChatDrawer({ open, setOpen, activityId }) {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const [localState, localDispatch] = useReducer(
    localReducer,
    initReducerState
  );
  const [chatText, setChatText] = useState("");

  useEffect(() => {
    if (activityId) {
      localDispatch({ type: "INIT_CHAT_LOAD" });
      loadComments();
    }
  }, [activityId]);

  function handleChatSubmit(e) {
    e.preventDefault();
    postComment();
  }

  async function loadComments() {
    setIsLoading(true);
    try {
      const { data } = await getCommentsByActivity(activityId, user.token);
      if (data.data.length === 0) {
        setIsLoading(false);
        localDispatch({ type: "COMPLETE_CHAT_LOAD", payload: data.data });
      } else {
        localDispatch({ type: "COMPLETE_CHAT_LOAD", payload: data.data });
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      handleAxiosError(error, dispatch);
    }
  }

  async function postComment() {
    try {
      setChatText("");
      let tempChatId = localState.tempChats.length + 1;
      localDispatch({
        type: "INIT_CHAT_SEND",
        payload: {
          id: tempChatId,
          timestamp: null,
          text: chatText,
          email: user.email,
          employee_id: user.roleId,
          firstname: user.firstname,
        },
      });
      const { data } = await createComment(
        { activity_id: activityId, text: chatText, tempId: tempChatId },
        user.token
      );
      localDispatch({
        type: "COMPLETE_CHAT_SEND",
        payload: {
          id: data.data.id,
          tempId: data.data.tempId,
          timestamp: data.data.timestamp,
          text: chatText,
          email: user.email,
          employee_id: user.roleId,
          firstname: user.firstname,
        },
      });
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  return (
    <Fragment>
      {/* <Button onClick={() => { setOpen(true) }}>RIGHT</Button> */}
      <Drawer
        id="someto"
        anchor="right"
        open={open}
        onClose={() => {
          setOpen(false);
          localDispatch({ type: "INIT_CHAT_LOAD" });
        }}
        className="pmt-activity-msg-box"
      >
        <Box
          width={{ sm: "200px", sm: "350px", md: "400px" }}
          height="92%"
          display="flex"
          flexDirection="column"
        >
          <Box px={2} py={1} backgroundColor="primary.light" color="#fff">
            <Typography variant="h6">Comments</Typography>
          </Box>
          <Box p={1} sx={{ height: "84%", overflowY: "scroll" }}>
            {isLoading ? (
              <Box textAlign="center" pt={3}>
                <CircularProgress />
              </Box>
            ) : (
              <>
                {localState.comments.map((c, i) => (
                  <Box key={i} display="flex" flexDirection="column" py={1}>
                    <Box
                      width="fit-content"
                      maxWidth="70%"
                      px={1}
                      sx={
                        c.employee_id === user.roleId
                          ? style.chatSelf
                          : style.chat
                      }
                      ml={c.employee_id === user.roleId ? "auto" : 0}
                    >
                      {c.text}
                    </Box>
                    <Box
                      maxWidth="70%"
                      p={0}
                      ml={c.employee_id === user.roleId ? "auto" : 0}
                    >
                      <span
                        style={{
                          fontSize: "0.7rem",
                          lineHeight: "0.7rem",
                          textTransform: "capitalize",
                        }}
                      >
                        {c.employee_id === user.roleId ? "" : c.firstname}{" "}
                        {new Date(c.timestamp).toLocaleString()}
                      </span>
                    </Box>
                  </Box>
                ))}
                {localState.tempChats.map((c, i) => (
                  <Box key={i} display="flex" flexDirection="column" py={1}>
                    <Box
                      maxWidth="70%"
                      p={1}
                      sx={style.chatSelf}
                      ml="auto"
                      mr={2}
                    >
                      {c.text}
                    </Box>
                    <Box
                      maxWidth="70%"
                      p={0}
                      ml={c.employee_id === user.roleId ? "auto" : 0}
                    >
                      <span
                        style={{ fontSize: "0.7rem", lineHeight: "0.7rem" }}
                      >
                        sending ...
                      </span>
                    </Box>
                  </Box>
                ))}
              </>
            )}
          </Box>
          <Box mt="auto" px={2} py={2} sx={{ backgroundColor: "#ededed" }}>
            <form
              onSubmit={handleChatSubmit}
              style={{ display: "flex", columnGap: "5px" }}
            >
              <TextField
                variant="outlined"
                type="text"
                value={chatText}
                onChange={(e) => {
                  setChatText(e.target.value);
                }}
                label="Enter Comment"
                required
                fullWidth
                size="small"
                autoFocus
              />
              <IconButton type="submit">
                <Send />
              </IconButton>
            </form>
          </Box>
        </Box>
      </Drawer>
    </Fragment>
  );
}
